module.exports = __webpack_public_path__ + "img/bf.e7755454.svg";